<template>
    <div>
        <b-modal ref="mdlExternalPrenotazioniPrenotaSlotModal" size="md" @shown="onShowModal" :title="title" centered scrollable no-close-on-backdrop :no-close-on-esc="true">
            <b-form @submit.prevent="onSubmit">
                <b-row>
                    <b-col xs="6" sm="6" md="6" lg="6" xl="6">
                        <label>Categoria</label>
                        <b-form-select v-model="jsonData.codiceCategoria" class="mb-2 mr-sm-2 mb-sm-0" :options="categorieOptions" :value="null" text-field="descrizione" value-field="categoria"> </b-form-select>
                    </b-col>
                    <b-col xs="6" sm="6" md="6" lg="6" xl="6">
                        <label>Tipo Trattamento</label>
                        <b-form-select v-model="jsonData.tipoTrattamento" class="mb-2 mr-sm-2 mb-sm-0" :options="tipoTrattamentoOptions" :value="null" text-field="text" value-field="value"> </b-form-select>
                    </b-col>
                    <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                        <label>Descrizione Diagnosi</label>
                        <b-form-input v-model="jsonData.diagnosi"></b-form-input>
                    </b-col>
                </b-row>
            </b-form>
            <template #modal-footer>
                <b-button v-b-tooltip.hover size="md" variant="danger" title="Annulla" @click="onClickAnnulla()" class="mr-1 no-text">
                    <b-icon icon="book" variant="outline-sucess"></b-icon>
                    Annulla
                </b-button>
                <b-button v-b-tooltip.hover size="md" variant="info " title="Salva" @click="saveDiagnosi()" class="mr-1 no-text">
                    <b-icon icon="book" variant="outline-sucess"></b-icon>
                    Salva
                </b-button>
            </template>
        </b-modal>
        <modal-error ref="cmpModalError"> </modal-error>
    </div>
</template>

<script>
import UtilityMixin from "../../utility/UtilityMixin";
import ModalError from "../../../template/components/modal/components/ModalError.vue";
export default {
    components: { ModalError },
    inject: ["openShowModalLoading", "closeShowModalLoading"],
    mixins: [UtilityMixin],
    data() {
        return {
            jsonData: {},
            title: "Aggiungi Diagnosi",
            categorieOptions: [],
            pathResourceCategorie: "/botoxdiagnosicategorie",
            pathResource: "/botoxdiagnosi",
            tipoTrattamentoOptions: [
                { value: null, text: "-Seleziona Valore-" },
                { value: "ESTETICO", text: "ESTETICO" },
                { value: "SANITARIO", text: "SANITARIO" },
            ],
            form: {
                idAgenda: null,
                idBox: null,
            },
        };
    },
    methods: {
        init(jsonData) {
            let me = this;
            me.loadCategorie();
            if (jsonData === null) {
                me.title = "Aggiungi Diagnosi";
                me.jsonData = { codiceCategoria: null, diagnosi: null, tipoTrattamento: null };
            } else {
                me.title = "Modifica Diagnosi";
                me.jsonData = jsonData;
            }
            this.open();
        },
        loadCategorie() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceCategorie, {}, me.loadCategorieDiagnosiSuccess, me.loadCategorieDiagnosiError);
        },
        loadCategorieDiagnosiSuccess(response) {
            let me = this;
            me.categorieOptions = response.data.data.list;
            me.categorieOptions.unshift({ categoria: null, descrizione: "-Seleziona Valore-" });
            me.$emit("afterLoadData");
        },
        loadCategorieDiagnosiError(error) {
            let me = this;
            me.$emit("afterLoadData");
            console.log("Errore nel caricamento dei dati", error);
        },

        open() {
            this.$refs.mdlExternalPrenotazioniPrenotaSlotModal.show();
        },
        hide() {
            this.$refs.mdlExternalPrenotazioniPrenotaSlotModal.hide();
        },
        onSubmit() {
            this.saveDiagnosi();
        },
        onShowModal() {},
        saveDiagnosi() {
            let me = this;
            this.openShowModalLoading();
            UtilityMixin.methods.saveResource(me.pathResource, me.jsonData, me.resultResponse, me.resultError);
        },

        resultResponse(response) {
            this.hide();
            response;
            this.$bvToast.toast("Diagonsi correttamente salvata", {
                title: "Operazione Avvenuta con successo",
                variant: "success",
                solid: true,
            });
            this.closeShowModalLoading();
        },
        resultError(error) {
            let me = this;
            me.$refs.cmpModalError.show(error.response.data.messaggio, true);
            this.closeShowModalLoading();
        },

        onClickAnnulla() {
            this.form = {
                idAgenda: null,
                idBox: null,
            };
            this.hide();
        },
    },
};
</script>

<style scoped></style>
